let language = {
    /************************************ 03:产品 ************************************/
    /***** B:业务错误 *******/
    // 用户未登录--添加产品到店铺
    A103B001: "Users can only add products to the store after logging in.",
    // 产品属性验证失败
    A103B002: "Product property verification failed. Please view the current product property.",
    // 产品名称处于编辑状态
    A103B003: "Please confirm the product name of the store!",
    // 添加产品到店铺，选中店铺不能为空
    A103B004: "Selected store cannot be empty!",
    // 添加产品到店铺，存在重复添加产品店铺
    A103B005: "There is a duplicate product store in the currently selected item store!",
    // 添加产品到店铺，partner未进行邮箱验证
    A103B006: "Please add the product after verifying the partner email first",
    // 产品属性校验失败
    "A103B007": 'Product Attribute Error',
    // 必填属性，为空
    "A103B008": 'The product attribute verification has failed. Please refresh. If the problem persists, contact us at {{supportmail}}',
    // 产品页面缺失
    "A103B009": 'Product page missing',
    // 产品页面缺失，请重新发布产品页
    "A103B0010": 'This product page has not been published yet, please go to the background of the website to publish the product.',
    // 非完备产品
    "A103B0011": "Incomplete product",
    // 非完备产品,不能直接添加到购物车
    "A103B0012": "Opps, incomplete products cannot be added directly to the shopping cart.",
    // 产品购买数量无效（成品产品）
    "A103B0013": "Quantity of product purchased",
    // 您当前的购买数量不符合,产品当前支持的购买数量期间为1-9999。
    "A103B0014": "Opps, Your current purchase quantity does not match, the product currently supports the purchase quantity period from 1-99999. ",
    "A103B0015": "Product price acquisition failed",
    "A103B0016": "{{storeProductType}}  store product types are not currently supported, please contact the administrator",
    "A103B0017": `',Error happen when calculation of formular.'`,
    "A103B0018": "Error calculating product shipping cost due to missing product attribute form data.",
    "A103B200001": "The product could not be found when calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    "A103B2000033": "There was an issue with the product attributes while calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    "A103B4000061": "There was an issue with the product weight while calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    "A103B4000063": "There was an issue with the shipping API while calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    "A103B30000027": "There was an issue with the shipping days while calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    "A103B300310": "The currency {{currentCurrency}} does not exist in the system.",
    "A103B3000601": "The current currency: {{currentCurrency}}, supported currency types on the {{appName}} platform: {{supportCurrencies}}",
};

export { language }